import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

export function useCountdowns(containerRef: RefObject<HTMLElement>) {
  const [countdowns, setCountdowns] = useState<Array<{ id: string; showSeconds: boolean }>>([]);

  useEffect(() => {
    if (!containerRef.current) return;

    const elements = containerRef.current.querySelectorAll('[data-countdown="true"]');
    const foundCountdowns = Array.from(elements).map((element) => ({
      id: element.id,
      showSeconds: element.getAttribute('data-show-seconds') === 'true',
    }));

    if (foundCountdowns.length > 0) {
      setCountdowns(foundCountdowns);
    }
  }, [containerRef]);

  return countdowns;
}
